<template>
<div class="rotationPicContainer">
  <div class="mainContent" :style="styleObject">
    <div class="handles">
      <handles>
        <template v-slot:right>
          <el-button class="primaryBtn" type="primary" @click="addItem" :title="dataList.length >= 3 ? '最多添加三张轮播图' : ''" :disabled="dataList.length >= 3">添加</el-button>
        </template>
      </handles>
    </div>
    <div class="tableBox">
      <border-table :tableData="dataList" :pages="pagination" :loading="tableLoading">
        <el-table-column prop="serial" label="显示序号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="title" label="名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isSystem" label="图片">
          <template slot-scope="scope">
            <img :src="`${baseUrlAddr}/front/picUploadAndDownload/download?fileName=${scope.row.picName}`" alt="" class="img-item">
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="添加时间" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button class="editBtn" type="text" icon="el-icon-edit-outline" @click="editItem(scope.row)">编辑</el-button>
            <el-button class="delBtn" type="text" icon="el-icon-delete" @click="delItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </border-table>
    </div>
  </div>
  <el-drawer :title="drawer.type === 'add' ? '添加图片' : '编辑图片'" size="600px" :visible.sync="drawer.show" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
    <pic-add-or-edit v-if="drawer.show" ref="addOrEdit" :drawer="drawer" @handleCancel="closeMess" @handleConfirm="handleConfirm"></pic-add-or-edit>
  </el-drawer>
</div>
</template>

<script>
import PicAddOrEdit from '@/components/systemMange/PicAddOrEdit'
import BorderTable from "@/components/common/BorderTable";
import Handles from "@/components/common/Handles";
export default {
  components: {
    PicAddOrEdit,
    BorderTable,
    Handles
  },
  data() {
    return {
      styleObject: {
        height: ''
      },
      dataList: [],
      tableLoading: false,
      pagination: {
        show: false,
        pageSize: 10,
        pageSizes: [5, 10, 20],
      },
      keyWord: '',
      drawer: {
        type: 'add',
        show: false,
        data: {
          serial: 1,
          title: '',
          file: null,
          targetUrl: ''
        }
      },
    };
  },
  created() {
    this.getTabList();
    this.makeheight()
  },
  methods: {
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    // ================================
    async getTabList() {
      this.tableLoading = true
      const {
        code,
        data
      } = await this.request.get("/admin/rotationPic/query", {})
      if (code !== 200) return

      this.dataList = data ? data : []
      this.tableLoading = false
      return
    },
    // 添加
    addItem() {
      this.drawer.type = "add";
      this.drawer.show = true;
      this.drawer.data = {
        serial: 1,
        title: '',
        file: null,
        targetUrl: ''
      }
    },
    // 编辑
    editItem(rowData) {
      this.drawer.type = "edit";
      this.drawer.show = true;
      this.drawer.data = {...rowData};
    },
    //关闭抽屉
    closeMess() {
      this.drawer.show = false
    },
    // 删除----------------------------
    delItem({
      id
    }) {
      this.$confirm("确认删除这些数据吗?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      }).then(async () => {
        this.tableLoading = true
        const {
          code
        } = await this.request.post(`/admin/rotationPic/del?id=${id}`)
        this.tableLoading = false
        if (code == 200) {
          this.getTabList()
          return this.$message.success('删除成功')
        }
        return
      }).catch((res) => {
        if (res == 'cancel') {
          return this.msg.info("已取消删除");
        }
      })
    },
    // 删除----------------------------
    handleConfirm() {
      this.drawer.show = false
      this.getTabList();
    }
  }
};
</script>

<style lang="scss" scoped>
.rotationPicContainer {
  height: 100%;

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
  }

  .handles {
    height: 50px;
    .primaryBtn{
      padding: 0 15px;
    }
  }

  .delBtn {
    color: rgb(237, 64, 20);
  }

  .img-item {
    width: 50px;
    height: 50px;
  }
}
</style><style lang="scss">
.rotationPicContainer {
  // .tableBox {
  //   .el-table {
  //     border: 1px solid #E6E6E6;
  //     height: 100%;
  //     padding-bottom: 0px;
  //     box-sizing: border-box;
  //     border-bottom: none;
  //   }
  // }
}
</style>
